import React, { Fragment, useEffect } from "react";
import { Form, Col, Row } from "react-bootstrap";
import { Field } from "redux-form";
import TextInput from "../../../../../../../partials/form/TextInput";
import TextArea from "../../../../../../../partials/form/TextArea";
import DateInput from "../../../../../../../partials/form/DateInput";
import MultiSelect from "../../../../../../../partials/form/MultiSelect";

const EnquiryItem = ({ fields, meta: { error, submitFailed }, label ,numSelected}) => {
  const allocation = [
    {
      label: "Unallocated( ALL )",
      value: "1",
    },
    {
      label: "Open Tenants",
      value: "2",
    },
    {
      label: "Sarah",
      value: "3",
    },
  ];
  const source = [
    {
      label: "My Tenants",
      value: "1",
    },
    {
      label: "Open Tenants",
      value: "2",
    },
    {
      label: "Sarah",
      value: "3",
    },
  ];
    useEffect(() => {
        console.log(numSelected)
        numSelected.map(obj => {
            fields.push({date:new Date(), address:obj.address});
         })
      }, []);
  return (
    <Fragment>
        <div className="makeAnOfferItem">
        {fields.map((offer, index,members) => (
        <div>
          <Form.Row>
            <Col md={6}>
              <Form.Group as={Row} >
                <Form.Label column sm={4}>
                  Listing:
                </Form.Label>
                <Form.Label column sm={8}>
                {members.get(index).address} 
                </Form.Label>
              </Form.Group>
            </Col>
          </Form.Row>
          <Form.Row>
            <Col md={6}>
              <Form.Group as={Row} >
                <Form.Label column sm={4}>
                  Allocation:
                </Form.Label>
                <Col sm={8}>

                <Field
                    name="allocation"
                    placeholder="Unallocated(all)"
                    component={MultiSelect}
                    showBottom={false}
                    isMulti={true}
                    options={allocation}
                  />
                </Col>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group as={Row} controlId="formHorizontalPassword">
                <Form.Label column sm={4}>
                  Source:
                </Form.Label>
                <Col sm={8}>
                <Field
                    name="source"
                    placeholder="Select an Enquiry Source"
                    component={MultiSelect}
                    showBottom={false}
                    isMulti={false}
                    options={allocation}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Form.Row>
          <Form.Row>
            <Col md={12}>
              <Form.Group as={Row} >
                <Form.Label column sm={2}>
                  Comments:
                </Form.Label>
                <Col sm={10}>
                  <Field
               name={`${offer}.comments`}
                type="textarea"
                rows="3"
                component={TextArea}
                placeholder="Comment about the offer"
              />
                </Col>
              </Form.Group>
            </Col>
          </Form.Row>
          <hr/>
        </div>
        
      ))}
        </div>
      
    </Fragment>
  );
};

export default EnquiryItem;
